import { Component } from "@angular/core";
import { EceButtonComponent } from "../ece.button.component";

@Component({
    selector: "ece-btn-forward-admin",
    templateUrl: "./forward-admin-button.component.html",
    styleUrls: ["./forward-admin-button.component.scss"],
    standalone: false
})
export class ForwardAdminButtonComponent extends EceButtonComponent {}
